package com.exura.components.icons

import androidx.compose.runtime.Composable
import com.exura.ui.Dimens
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.height

@Composable
internal fun ExuraLogo(modifier: Modifier = Modifier) {
    Row(modifier = Modifier.height(Dimens.brandingLogoDefaultHeight).then(modifier)) {
        ExuraIcon(modifier = Modifier.fillMaxHeight())
        ExuraText(modifier = Modifier.fillMaxHeight())
    }
}

@Composable
internal fun ExuraIcon(modifier: Modifier = Modifier) {
    Box(
        modifier = Modifier
            .aspectRatio(BrandGeometry.ICON_RATIO)
            .height(Dimens.brandingLogoDefaultHeight)
            .then(modifier)
    ) {
        ExuraIconSvg()
    }
}

@Composable
internal fun ExuraText(modifier: Modifier = Modifier) {
    Box(
        modifier = Modifier
            .aspectRatio(BrandGeometry.TEXT_RATIO)
            .height(Dimens.brandingLogoDefaultHeight)
            .then(modifier)
    ) {
        ExuraTextSvg()
    }
}

@Composable
private fun ExuraIconSvg() {
    Svg(attrs = {
        viewBox(0, 0, BrandGeometry.ICON_WIDTH, BrandGeometry.HEIGHT)
        attr("fill", "currentColor")
        style {
            property("height", "100%")
            property("width", "100%")
        }
    }) {
        Path {
            d(
                "M135.03,19.57c-3.08-7.73-9.25-13.9-16.98-16.98-22.14-8.82-43.77,6.07-45.69,27.15l-2.66," +
                        "29.05c-.21,2.25-3.34,2.61-4.05.47l-10.63-31.83c-2.97-8.91-11.3-14.91-20.69-14.91h-2.29c-10.78," +
                        "0-19.53,8.74-19.53,19.53v2.29c0,9.39,6.01,17.72,14.91,20.69l31.83,10.63c2.14.71,1.78,3.85-.47," +
                        "4.05l-29.05,2.67c-21.07,1.92-35.97,23.55-27.15,45.69,3.08,7.73,9.25,13.9,16.98,16.98,22.14," +
                        "8.82,43.77-6.07,45.69-27.15l2.66-29.05c.21-2.25,3.34-2.61,4.05-.47l10.63,31.83c2.97,8.91,11.3," +
                        "14.91,20.69,14.91h0c12.05,0,21.81-9.77,21.81-21.81,0-9.39-6.01-17.72-14.91-20.69l-31.82-10.63c-2." +
                        "14-.71-1.78-3.85.47-4.05l29.04-2.67c21.07-1.92,35.97-23.55,27.15-45.69Z"
            )
        }
    }
}

@Composable
private fun ExuraTextSvg() {
    Svg(attrs = {
        viewBox(BrandGeometry.ICON_WIDTH, 0, BrandGeometry.TEXT_WIDTH, BrandGeometry.HEIGHT)
        attr("fill", "currentColor")
        style {
            property("height", "100%")
            property("width", "100%")
        }
    }) {
        Path { d("M155.44,68.81c0-19.13,14.03-33.16,33.93-33.16s33.67,14.03,33.67,33.16v2.46c0,1.1-.9,2-2,2h-52.85c1.79,11.23,10.2,17.47,21.17,17.47,7.74,0,13.3-2.29,17.01-7.2.39-.51.98-.84,1.62-.84h9.19c1.52,0,2.49,1.63,1.76,2.97-5.46,10.02-16.19,16.3-29.58,16.3-19.9,0-33.93-14.03-33.93-33.16ZM210.29,62.43c-2.42-10.08-10.71-15.56-20.92-15.56s-18.37,5.61-20.79,15.56h41.71Z") }
        Path { d("M249.14,67.07l-20.43-26.55c-1.01-1.32-.07-3.22,1.58-3.22h9.85c.64,0,1.24.3,1.61.82l15.77,21.59c.8,1.09,2.43,1.09,3.23,0l15.77-21.59c.38-.52.98-.82,1.61-.82h9.45c1.66,0,2.6,1.91,1.58,3.22l-20.53,26.54c-.56.72-.56,1.73,0,2.45l21.52,27.56c1.03,1.31.09,3.23-1.58,3.23h-9.81c-.64,0-1.23-.3-1.61-.81l-16.8-22.77c-.8-1.08-2.42-1.08-3.22,0l-16.8,22.77c-.38.51-.97.81-1.61.81h-9.45c-1.66,0-2.6-1.91-1.58-3.23l21.42-27.57c.56-.72.56-1.73,0-2.45Z") }
        Path { d("M300.97,70.21v-30.91c0-1.1.9-2,2-2h8.12c1.1,0,2,.9,2,2v30.91c0,13.65,7.53,20.54,19.01,20.54s19.01-6.89,19.01-20.54v-30.91c0-1.1.9-2,2-2h8.12c1.1,0,2,.9,2,2v30.91c0,20.92-12.5,31.76-31.12,31.76s-31.12-10.71-31.12-31.76Z") }
        Path { d("M375.71,63.2c0-18.62,10.97-27.55,27.17-27.55s27.04,8.93,27.04,27.68v.64h-11.99v-.77c0-11.61-6.12-16.33-15.05-16.33s-15.05,4.72-15.05,16.33v35.12c0,1.1-.9,2-2,2h-8.12c-1.1,0-2-.9-2-2v-35.12Z") }
        Path { d("M435.66,69.32c0-19.77,14.03-33.67,34.06-33.67s33.55,13.52,33.55,33.67v29c0,1.1-.9,2-2,2h-7.1c-1.1,0-2-.9-2-2v-11.78c-4.21,10.2-13.52,15.43-24.49,15.43-16.45,0-32.02-11.86-32.02-32.65ZM491.27,68.81c0-12.76-8.67-21.94-21.68-21.94s-21.68,9.18-21.68,21.94,8.67,21.94,21.68,21.94,21.68-9.18,21.68-21.94Z") }
    }
}

private object BrandGeometry {
    const val HEIGHT = 138
    const val ICON_WIDTH = 155
    const val TEXT_WIDTH = 348

    const val ICON_RATIO = ICON_WIDTH.toFloat() / HEIGHT.toFloat()
    const val TEXT_RATIO = TEXT_WIDTH.toFloat() / HEIGHT.toFloat()
}
